module.exports = __webpack_public_path__ + "media/images/green_bolt_icon-b4815d5c060cf5b28430ace78460a1a1.png";